<template>
  <div class="container-fluid Section Section--contact">
    <div class="container mt-5">
      <div class="row">

        <div class="col-md-5 d-flex flex-column justify-content-center mb-5 mb-lg-0 px-lg-5">
          <h2 class="Reveal--sequenced">Contact Us</h2>
          <p class="Reveal--sequenced">
            For questions, bookings, and availability, please contact us at (505) 792-1110 ext.1 or toll-free in the US (855) 898-6824, use our online inquiry form, or email us at sales@ideum.com. At this time, rentals are only available in the United States.
          </p>
          <a class="Button Button--emerald mt-4 Reveal--sequenced" target="_blank" href="https://ideum.com/contact" title="Contact Rentals at Ideum" rel="noopener">
            <span class="Button-text">Contact Ideum</span>
          </a>
        </div>

        <div class="col-md-7 Reveal">
          <div class="Intrinsic-wrapper Intrinsic-wrapper--5x4">
            <img
              class="Intrinsic-item lazyload"
              :data-src="'./static/images/' + 'ideum-contact-touch--4x5--600.jpg'"
              alt="Hiqh-quality, custom-made multitouch table created by Ideum.">
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
@import './../assets/_variables.scss';

.Section--contact {
  background-color: $colorLightgray;
  margin-top: -9em;
  padding-top: 12em;
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue